import React from 'react'
import { Header } from 'reaxl-header'

export default () => <Header id={'globalHeader'} showWallet={false} showHeaderBadge={false} />
